export default __webpack_public_path__ + "static/foto1-a3ab2bcf7ac3b84120a2a677a8b6e8fb.jpg";